import React from 'react';
import { type IIconProps } from '../../dm/icons.js';

export const AllUpperIcon = ({ className, color, size }: IIconProps) => {
  return (
    <svg
      fill={color}
      className={className}
      height={size}
      width={size}
      viewBox="0 0 32 32"
      id="icon"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g strokeWidth="0" />
      <g strokeLinecap="round" strokeLinejoin="round" />
      <g>
        <polygon points="23 27 23 15 18 15 18 13 30 13 30 15 25 15 25 27 23 27" />
        <polygon points="11 27 11 8 2 8 2 6 22 6 22 8 13 8 13 27 11 27" />
      </g>
    </svg>
  );
};
